export default "__VITE_ASSET__BVRh2mDr__"